import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import SchoolWebsite from "@/components/SchoolWebsite/SchoolWebsite.vue";
import BitsemsLogin from "@/components/Bitsems/BitsemsLogin.vue";

import IncomeSpreadSheetModule from "@/modules/Incomes/routes.js";
import ExpenseSpreadSheetModule from "@/modules/Expenses/routes.js";
import ResetPasswordModule from "@/modules/ResetPassword/routes.js";
import BulkPaymentsModule from "@/modules/BulkPayments/routes.js";
import BulkExpensesModule from "@/modules/BulkExpenses/routes.js";
import SwitchboardsModule from "@/modules/Switchboards/routes.js";
import FinanceDashboardModule from "@/modules/FinanceDashboard/routes.js";
// import ManageDatatablesModule from "@/modules/ManageDatatables/routes.js";
import IDCardsModule from "@/modules/IDCards/routes.js";
import BulkSMSModule from "@/modules/BulkSMS/routes.js";
import TargetProfileModule from "@/modules/TargetProfile/routes.js";
import EventsCalendarModule from "@/modules/EventsCalendar/routes.js";
import CrudDatabasesModule from "@/modules/CrudDatabases/routes.js";
import SettingsModule from "@/modules/Settings/routes.js";
import ManageFrontPageModule from "@/modules/ManageFrontPage/routes.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "school-website",
    component: SchoolWebsite,
  },
  ...ManageFrontPageModule,
  ...SwitchboardsModule,
  ...IncomeSpreadSheetModule,
  ...ExpenseSpreadSheetModule,
  ...ResetPasswordModule,
  ...BulkPaymentsModule,
  ...BulkExpensesModule,
  ...FinanceDashboardModule,
  ...IDCardsModule,
  ...BulkSMSModule,
  ...TargetProfileModule,
  ...EventsCalendarModule,
  ...CrudDatabasesModule,
  ...SettingsModule,
  {
    path: "/add-your-school",
    name: "add-your-school",
    component: () => import("@/components/SchoolWebsite/AddYourSchool.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import("@/components/SchoolWebsite/Templates/Template1/Login/Login.vue"),
  },
  {
    path: "/bitsems-login",
    name: "bitsems-login",
    component: BitsemsLogin,
  },
  {
    path: "/bitsems-register",
    name: "bitsems-register",
    component: () => import("@/components/Bitsems/BitsemsRegister.vue"),
  },
  {
    path: "/elearning",
    name: "elearning",
    component: () => import("@/views/Dashboard.vue"),
  },
  {
    path: "/student-finance-dashboard",
    name: "student-finance-dashboard",
    component: () =>
      import("@/components/SchoolFees/StudentFinanceDashboard.vue"),
  },
  {
    path: "/school-fees-structures",
    name: "school-fees-structures",
    component: () => import("@/components/SchoolFees/SchoolFeesStructures.vue"),
  },
  {
    path: "/edit-fees-structures",
    name: "edit-fees-structures",
    component: () => import("@/components/SchoolFees/EditFeesStructures.vue"),
  },
  {
    path: "/get-payslips-pdf",
    name: "get-payslips-pdf",
    component: () => import("@/components/StaffAndHR/PayslipsPDF.vue"),
  },
  {
    path: "/manage-employees",
    name: "manage-employees",
    component: () => import("@/components/StaffAndHR/ManageStaff.vue"),
  },
  {
    path: "/salaries-and-payslips",
    name: "salaries-and-payslips",
    component: () => import("@/components/StaffAndHR/ManagePayroll.vue"),
  },

  {
    path: "/video-tutorials",
    name: "video-tutorials",
    component: () => import("@/components/Bitsems/VideoTutorials.vue"),
  },
  {
    path: "/learning-materials",
    name: "learning-materials",
    component: () => import("@/components/Elearning/LearningMaterials.vue"),
  },
  {
    path: "/admissions",
    name: "admissions",
    component: () =>
      import("@/components/SchoolAdmin/Admissions/Admissions.vue"),
  },
  {
    path: "/apply-online",
    name: "apply-online",
    component: () =>
      import("@/components/OnlineApplication/OnlineApplication.vue"),
  },
  {
    path: "/pay-online",
    name: "pay-online",
    component: () => import("@/components/OnlinePayment/PayOnline.vue"),
  },
  {
    path: "/payment-successful",
    name: "payment-successful",
    component: () => import("@/components/OnlinePayment/PaymentSuccessful.vue"),
  },
  {
    path: "/notify-payment",
    name: "notify-payment",
    component: () => import("@/components/OnlinePayment/NotifyPayment.vue"),
  },
  {
    path: "/cancel-payment",
    name: "cancel-payment",
    component: () => import("@/components/OnlinePayment/CancelPayment.vue"),
  },
  {
    path: "/previous-years",
    name: "previous-years",
    component: () => import("@/components/PreviousYears/PreviousYears.vue"),
  },
  {
    path: "/students-owing",
    name: "students-owing",
    component: () => import("@/components/SchoolAdmin/StudentsOwing.vue"),
  },
  {
    path: "/students-statements",
    name: "students-statements",
    component: () =>
      import("@/components/Incomes/StudentsStatementsComponent.vue"),
  },
  {
    path: "/view-student-statement",
    name: "view-student-statement",
    component: () => import("@/components/Incomes/StudentStatementDMZ.vue"),
  },
  {
    path: "/financial-accounts",
    name: "financial-accounts",
    component: () => import("@/components/BudgetAndFinances/Accounts.vue"),
  },
  {
    path: "/finance-expenses",
    name: "finance-expenses",
    component: () =>
      import("@/components/BudgetAndFinances/Expenses/Expenses.vue"),
  },
  {
    path: "/financial-budgets",
    name: "financial-budgets",
    component: () =>
      import("@/components/BudgetAndFinances/Budgets/Budgets.vue"),
  },
  {
    path: "/website-dashboard",
    name: "website-dashboard",
    component: () => import("@/components/SchoolWebsite/WebsiteDashboard.vue"),
  },
  {
    path: "/manage-images",
    name: "manage-images",
    component: () => import("@/components/SchoolWebsite/WebsiteImagesCrud.vue"),
  },
  {
    path: "/images-gallery",
    name: "images-gallery",
    component: () => import("@/components/SchoolWebsite/WebsiteGallery.vue"),
  },
  {
    path: "/website-manage-posts",
    name: "website-manage-posts",
    component: () =>
      import("@/components/SchoolWebsite/WebsiteManagePosts.vue"),
  },
  {
    path: "/read-post",
    name: "read-post",
    component: () => import("@/components/SchoolWebsite/WebsitePostRead.vue"),
    props: true,
  },
  {
    path: "/website-manage-profile",
    name: "website-manage-profile",
    component: () => import("@/components/SchoolWebsite/WebsiteImagesCrud.vue"),
  },
  {
    path: "/manage-students",
    name: "manage-students",
    component: () => import("@/components/ManageStudents/ManageStudents.vue"),
  },
  {
    path: "/fees-spreadsheet",
    name: "fees-spreadsheet",
    component: () => import("@/components/SchoolAdmin/FeesSpreadsheet.vue"),
  },
  {
    path: "/capture-marks",
    name: "capture-marks",
    component: () => import("@/components/ManageStudents/CaptureMarks.vue"),
  },
  {
    path: "/marks-schedule",
    name: "marks-schedule",
    component: () => import("@/components/ManageStudents/MarksSchedule.vue"),
  },
  {
    path: "/manage-staff-and-salaries",
    name: "manage-staff-and-salaries",
    component: () => import("@/components/StaffAndHR/ManageStaff.vue"),
  },
  {
    path: "/academic-reports",
    name: "academic-reports",
    component: () => import("@/components/SchoolAdmin/StudentReport.vue"),
  },
  {
    path: "/school-galleries",
    name: "school-galleries",
    component: () => import("@/components/SchoolGallery/SchoolGalleries.vue"),
  },
  {
    path: "/sasams-uploads",
    name: "sasams-uploads",
    component: () => import("@/components/SchoolAdmin/SASAMSUploads.vue"),
  },

  {
    path: "/payments-receipt",
    name: "payments-receipt",
    component: () => import("@/components/Incomes/PaymentReceiptComponent.vue"),
  },

  {
    path: "/students-owing-pdf-list",
    name: "students-owing-pdf-list",
    component: () =>
      import("@/components/SchoolAdmin/StudentsOwingPDFList.vue"),
  },
  {
    path: "/offline-payments",
    name: "offline-payments",
    component: () => import("@/components/Incomes/OfflinePayment.vue"),
  },
  {
    path: "/lesson-presentation/:lessonInfo",
    name: "lesson-presentation",
    component: () => import("@/views/LessonPresentation.vue"),
  },
  {
    path: "/balance-brought-forward",
    name: "balance-brought-forward",
    component: () =>
      import("@/components/SchoolAdmin/BalanceBroughtForward.vue"),
  },
  {
    path: "/manage-users",
    name: "manage-users",
    component: () => import("@/views/ManageUsers.vue"),
  },
  {
    path: "/crud-reports",
    name: "crud-reports",
    component: () => import("@/components/myLibrary/CrudReports.vue"),
  },
  {
    path: "/crud-topics",
    name: "crud-topics",
    component: () => import("@/views/CrudTopics.vue"),
  },
  {
    path: "/crud-lesson",
    name: "crud-lesson",
    component: () => import("@/views/CrudLesson.vue"),
  },
  {
    path: "/create-lesson-presentation/:item",
    name: "create-lesson-presentation",
    props: true,
    component: () => import("@/views/CreateLessonPresentation.vue"),
  },

  {
    path: "/create-slides",
    name: "create-slides",
    component: () => import("@/views/CreateSlides.vue"),
  },

  {
    path: "/live-videos",
    name: "live-videos",
    props: true,
    component: () => import("@/components/Elearning/LiveVideo.vue"),
  },
  {
    path: "/crud-elearning",
    name: "crud-elearning",
    component: () => import("@/components/Elearning/CrudElearning.vue"),
  },
  {
    path: "/admin-manage-database",
    name: "admin-manage-database",
    component: () => import("@/components/SchoolAdmin/AdminManageDatabase.vue"),
  },

  {
    path: "/related-table",
    name: "related-table",
    component: () => import("@/components/myLibrary/TableDialog.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/components/Register.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/components/Contact.vue"),
  },

  {
    path: "/donation",
    name: "donation",
    component: () => import("@/components/Donation.vue"),
  },
  {
    path: "/subjects/:gradeId/:gradeName",
    name: "subjects",
    component: () => import("@/views/Subjects.vue"),
  },

  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    localStorage.getItem("authenticated") != null &&
    localStorage.getItem("token") != null
  ) {
    const emis = store.getters.getUserSchool.emis;
    if (emis != 500342065 && emis != 500499130) {
      next();
    } else if (to.path == "/switchboard") {
      next();
    } else {
      next("/switchboard");
    }
  } else {
    if (
      to.path == "/login" ||
      to.path == "/bitsems-login" ||
      to.path == "/" ||
      to.path == "/register" ||
      to.path == "/bitsems-register" ||
      to.path == "/images-gallery" ||
      to.path == "/reset-password" ||
      to.path == "/resetting-password" ||
      to.path == "/view-student-statement"
    ) {
      next();
    } else {
      next("/login");
    }
  }
});

export default router;
